module.exports = __webpack_public_path__ + "img/t5-c8.3093012d.png";